module.exports = __webpack_public_path__ + "static/media/001-Ueberzeugen_ID_5.1dc0be98.mp3";